<div
  [ngClass]="statsAndCount.isRedirect ? 'p-g-6 p-md-4 p-lg-2 admin-stats-counts cursor-pointer' : 'p-g-6 p-md-4 p-lg-2 admin-stats-counts'"
  (click)="statsAndCount.isRedirect?redirectTo(statsAndCount.url, statsAndCount.status):''">
  <div class="p-g">
    <h2 class="admin-dash-stats-count  mb-0">{{statsAndCount.count}}</h2>
    <h3 [ngClass]="statsAndCount.dateLabel !== null ? 'mb-0 admin-dash-stats-count':'admin-dash-stats-count'">
      {{statsAndCount.dateLabel}}</h3>
  </div>
  <div class="p-g">
    <h3 class="admin-dash-stats-label uppercase">{{statsAndCount.label}}</h3>
  </div>
</div>
